import TARIFF_BUNDLE_MONTHLY from "./tariffs/tariffBundleMonthly.content";
import TARIFF_BUNDLE_YEARLY from "./tariffs/tariffBundleYearly.content";
import TARIFF_BUNDLE_LIFETIME from "./tariffs/tariffBundleLifetime.content";

export const MODES = {
  modal: "modal",
  iframe: "iframe",
  pricingPage: "pricingPage"
};
export const PERIODS = [
  "monthly",
  "yearly",
  "lifetime"
];
export const TABLE_PERIODS = ["common", ...PERIODS];
export const REFS_HIDE_TABLE = {
  common: "toggleRef",
  monthly: "monthlyNavRef",
  yearly: "yearlyNavRef",
  lifetime: "lifetimeNavRef"
};
export const AVAILABLE_TARIFFS = {
  monthly: "bundleMonthly",
  yearly: "bundleYearly",
  lifetime: "bundleLifetime"
};
export const AVAILABLE_OPTIONS = {
  monthly: ["PL", "R"],
  yearly: ["PL", "R"],
  lifetime: []
};
export const TARIFF_INFORMATION = {
  bundleMonthly: TARIFF_BUNDLE_MONTHLY,
  bundleYearly: TARIFF_BUNDLE_YEARLY,
  bundleLifetime: TARIFF_BUNDLE_LIFETIME
};


